module.exports = __webpack_public_path__ + "media/images/site/unimestre_logo-e4b4705fb87fb646b045b7087693e051.png";